module.exports = __webpack_public_path__ + "img/surgery.f9bed077.png";